import React from 'react';

const WhyChooseUs = ({ title = 'Why Choose Us', sections = [] }) => {
  // Default sections if none provided
  const defaultSections = [
    {
      title: 'Expert Reviews Tailored to You:',
      content: "At bluetidesolutions, our team of travel professionals personally visits every hotel and evaluates its offerings—be it service quality or amenities. This thorough approach guarantees that our reviews are based on genuine experiences, providing you with trustworthy information to help you make informed decisions about where to stay."
    },
    {
      title: 'A Diverse Range of Options:',
      content: "We offer a wide array of hotels to cater to every traveler's needs. Whether you're looking for lavish luxury, a quaint boutique hotel, a sustainable eco-friendly option, a budget-friendly stay, or an exciting casino experience, bluetidesolutions has you covered. Our diverse selection allows us to deliver customized recommendations to match your personal travel preferences."
    },
    {
      title: 'Designed with You in Mind:',
      content: "We prioritize your experience. Our website is easy to navigate, with advanced filters to help you find the perfect hotel based on your specific requirements. We also value your input and continuously update our content to reflect your feedback, ensuring that your hotel search is as smooth and enjoyable as possible. Count on us to help you find the best hotel for a memorable stay in New Zealand."
    }
  ];

  const displaySections = sections.length > 0 ? sections : defaultSections;

  // Function to convert markdown in the content to HTML
  const processContent = (content) => {
    if (typeof content !== 'string') return content;
    // Replace markdown ** with <strong> tags
    let processedContent = content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    return processedContent;
  };

  // Function to process HTML in title
  const renderTitle = (title) => {
    if (React.isValidElement(title)) {
      // If it's already a React element, return it as is
      return title;
    } else if (typeof title === 'string' && title.includes('<')) {
      // If it's a string with HTML tags, render it with dangerouslySetInnerHTML
      return <span dangerouslySetInnerHTML={{ __html: title }} />;
    } else {
      // Otherwise, just return the title as regular text
      return title;
    }
  };

  return (
    <section className="section gray-bg">
      <div className="container">
        <h2 className="section-title-txt">
          {renderTitle(title)}
        </h2>
        <div className="content">
          {displaySections.map((section, index) => (
            <React.Fragment key={index}>
              <h3>{renderTitle(section.title)}</h3>
              <p dangerouslySetInnerHTML={{ __html: processContent(section.content) }} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;